import { bonzai, type InferBonzai } from "bonzai"
import * as api from "./v3Endpoints"
import { apiV3Mock } from "./v3Mock"
export { apiV3Mock } from "./v3Mock"

const apiV3 = import.meta.env.MODE === "test" ? apiV3Mock.mocks : api

export type V3 = InferBonzai<typeof v3>
export const v3 = bonzai(apiV3)
